import type { IconSource } from "@shopify/polaris";
import {
  HomeIcon,
  AppsIcon,
  TargetIcon,
  GiftCardIcon,
  PersonSegmentIcon,
  ChartVerticalFilledIcon,
  SettingsIcon,
} from "@shopify/polaris-icons";

export type AppNavItem = {
  label: string;
  path: string;
  icon: IconSource;
};

/** Primary nav: embedded App Bridge menu + dev-only Polaris sidebar (same destinations). */
export const APP_NAV_ITEMS: AppNavItem[] = [
  { label: "Dashboard", path: "/", icon: HomeIcon },
  { label: "Games", path: "/games", icon: AppsIcon },
  { label: "Campaigns", path: "/campaigns", icon: TargetIcon },
  { label: "Rewards", path: "/rewards", icon: GiftCardIcon },
  { label: "Segments", path: "/segments", icon: PersonSegmentIcon },
  { label: "Analytics", path: "/analytics", icon: ChartVerticalFilledIcon },
  { label: "Settings", path: "/settings", icon: SettingsIcon },
];

/** Longest-prefix match for nested routes (e.g. /campaigns/:id → Campaigns). */
export function findActiveNavItemIndex(pathname: string): number {
  const normalized = pathname || "/";
  let bestIdx = 0;
  let bestLen = -1;

  APP_NAV_ITEMS.forEach((item, i) => {
    const p = item.path;
    if (p === "/") {
      if (normalized === "/" || normalized === "") {
        if (1 > bestLen) {
          bestLen = 1;
          bestIdx = i;
        }
      }
      return;
    }
    if (normalized === p || normalized.startsWith(`${p}/`)) {
      if (p.length > bestLen) {
        bestLen = p.length;
        bestIdx = i;
      }
    }
  });

  return bestIdx;
}
